import MuiAppBar from '@mui/material/AppBar';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { getTimeDeltaInDays } from '~/shared/date/date';

import { companyOnboardingRoutePath } from '../../legacy/company-onboarding/route-config';
import { TrialInformation, trialPeriodDays } from '../../legacy/purchase/TrialInformation';
import { route } from '../pages/onboarding/constants';
import { CustomizationInfo } from './CustomizationInfo';
import { MenuBarV2 } from './menu-bar-v2/MenuBarV2';

const disableAppBarRoutes = [route.patterns.onboarding, companyOnboardingRoutePath];

export const AppBar: FunctionComponent = () => {
    const {
        applicationState: { customization, location },
    } = useContext(ApplicationContext);
    const { pathname } = location;

    if (disableAppBarRoutes.includes(pathname)) {
        return null;
    }

    const tenantCreatedAt = customization.get('tenantCreatedAt');
    const daysRemaining = tenantCreatedAt.mapOr(0, (createdAt) => {
        return Math.max(0, trialPeriodDays - getTimeDeltaInDays(new Date(), createdAt));
    });

    return (
        <MuiAppBar
            component="header"
            elevation={0}
            position="sticky"
            sx={{
                backgroundColor: 'background.default',
            }}
        >
            {customization
                .get('tenantMode')
                .mapOr(null, (mode) => (mode === 'trial' ? <TrialInformation daysRemaining={daysRemaining} /> : null))}
            <CustomizationInfo />
            <MenuBarV2 />
        </MuiAppBar>
    );
};
